export enum ScanTypes {
  PrivateCloud = 1,
  Cloud = 2,
  Local = 3,
}
